import classNames from 'classnames';
import React, { PureComponent } from 'react';

import { ChevronDownSmall } from '@vimeo/bokeh-icons';

import styles from './Accordion.module.scss';

const isEnterPressed = (event) => {
  const key = event.key || event.keyCode;

  if (key === 'Enter' || key === 13) {
    return true;
  }

  return false;
};

class Accordion extends PureComponent {
  state = {
    open: false,
  };

  toggle = () => {
    this.setState((el) => ({
      open: !el.open,
    }));
  };

  render() {
    const { heading, children } = this.props;
    const { open } = this.state;
    return (
      <div>
        <div
          onClick={this.toggle}
          tabIndex="0"
          className={styles.header}
          onKeyDown={(e) => (isEnterPressed(e) ? this.toggle() : null)}
        >
          {heading}
          <ChevronDownSmall className={classNames(styles.arrow, open ? styles.up : styles.down)} />
        </div>
        {open ? children : null}
      </div>
    );
  }
}

export default Accordion;
